export default __webpack_public_path__ + "static/media/Calendar.8b2fd055.png";